export const BASE_URL="https://nest.fringale.one/"